<!--
 * @Version      : V1.0
 * @Date         : 2025-04-07 14:52:42
 * @fileName     : 我方主体详情
 * @Description  :
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <descriptions v-if="!showDesc" :status="status" :row-data="rowData" :columns="columns" :span="2" :rules="rules"
        ref="descriptionsRef"></descriptions>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <!-- <el-button type="primary" @click="temporarilyStore()">暂存</el-button> -->
      <el-button @click="clearForm()">清空</el-button>
    </div>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { queryOurSubInfoDetailsApi, queryOurSubInfoAddApi, queryOurSubInfoEditApi } from '@/api/basicInfo/index'
export default {
  components: {
    descriptions
  },
  props: {
    title: {
      type: String,
      default: '我方主体详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  watch: {
    //当弹框关闭刷新列表
    // dialogDrawer(val){
    //   if(!val){
    //     this.queryData()
    //   }
    // }
  },
  data() {

    return {
      dialogDrawer: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'unitName', label: '单位名称', span: 2, placeholder: '请输入单位名称', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'unitName', label: '单位简称', span: 2, placeholder: '请输入单位简称', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'unitAddress', label: '单位地址', span: 2, placeholder: '请输入单位地址', input: 'input', type: 'text', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        unitName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
        ],
        // unitName: [
        //   { required: true, message: '请输入单位简称', trigger: 'blur' },
        // ],
        unitAddress: [
          { required: true, message: '请输入单位地址', trigger: 'blur' },
        ],
      }
    }
  },
  mounted() {
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))
  },
  methods: {
    //核心方法 判断是否是新增 还是编辑
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
    },
    //详情查询
    queryDetails(row) {
      this.loading = true;
      this.showDesc = true;
      queryOurSubInfoDetailsApi(row).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (this.status == 'edit' || this.status == 'view') {
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              this.columns[i].defaultValue = this.rowData[this.columns[i].key];
            }
          }

        }
      })
    },
    //提交
    submit(str = null) {
      this.$refs.descriptionsRef.submit().then(formData => {
        let params = {
          ...formData
        }
        this.loading = true;
        if (this.status == 'add') {
          queryOurSubInfoAddApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
            //当为暂存状态 则不关闭弹出窗
            //  if(str == 'temporarilyStore'){
            //   this.clearForm()
            //  }else{
            //   this.closeDrawer();
            //   this.queryData();
            //  }

          })
        }else{
          queryOurSubInfoEditApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
            //当为暂存状态 则不关闭弹出窗
            //  if(str == 'temporarilyStore'){
            //   this.clearForm()
            //  }else{
            //   this.closeDrawer();
            //   this.queryData();
            //  }

          })
        }

      })
    },
    //暂存 暂时不用
    temporarilyStore() {
      this.submit('temporarilyStore');
    },
    //清空描述组件form
    clearForm() {
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    }
  }
}
</script>

<style scoped lang="scss">
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}
::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}
::v-deep .el-breadcrumb__separator{
  color: #000;
}
</style>
